export const PRODUCT_TAGS = {
  SOLD_OUT: 'Sold Out',
}
